<template>
  <div class="left-menu">
    <div class="collapse-box" @click="collapseHandle">
      <span :class="isCollapse?'el-icon-s-fold':'el-icon-s-unfold'"></span>
    </div>
    <el-menu ref="menus" @select="selectMenu" :default-openeds="['0']" :default-active="defaultIndex" background-color="rgb(44, 95, 154)" text-color="#fff" active-text-color="#409EFF" unique-opened :collapse="isCollapse">
      <template v-for="(menu, index) in menus">
        <el-submenu v-if="menu.children && menu.children.length > 0" :index="index + ''">
          <template slot="title">
            <i v-if="!menu.icon" class="el-icon-menu"></i>
            <i v-else-if="menu.iconType === 0" :class="menu.icon"></i>
            <img class="menu-icon" v-else-if="menu.iconType === 1" :src="getImage(menu.icon)">
            <i v-else class="el-icon-menu"></i>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item v-if="menu.children" v-for="(child, cindex) in menu.children" :key="cindex" :index="index + '-' + cindex">
            <template slot="title">
              <i v-if="!child.icon" class="el-icon-menu"></i>
              <i v-else-if="child.iconType === 0" :class="child.icon"></i>
              <img class="menu-icon" v-else-if="child.iconType === 1" :src="getImage(child.icon)">
              <i v-else class="el-icon-menu"></i>
              <span>{{ child.name }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="index + ''">
          <template slot="title">
            <i v-if="!menu.icon" class="el-icon-menu"></i>
            <i v-else-if="menu.iconType === 0" :class="menu.icon"></i>
            <img class="menu-icon" v-else-if="menu.iconType === 1" :src="getImage(menu.icon)">
            <i v-else class="el-icon-menu"></i>
            <span>{{ menu.name }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    //选中左侧菜单
    selectLeftMenu: {
      type: Function
    }
  },
  data() {
    return {
      //默认选中菜单
      defaultIndex: '',
      //菜单
      menus: [],
      isCollapse:false,
    }
  },
  methods: {
    //点击顶部菜单时加载数据
    selectTopMenu: function(menus){
      this.menus = menus
      //默认选中第一个
      if(menus && menus.length > 0){
        //有二级菜单的情况
        if(menus[0].children && menus[0].children.length > 0){
          this.defaultIndex = '0-0'
          this.$refs.menus.activeIndex = this.defaultIndex
          this.selectLeftMenu(menus[0].children[0])
        }
        else {
          this.defaultIndex = '0'
          this.$refs.menus.activeIndex = this.defaultIndex
          this.selectLeftMenu(menus[0])
        }
      }
    },
    //菜单选中事件
    selectMenu: function(index, indexPath){
      let indexs = index.split('-')
      let menu = indexs.length === 1 ? this.menus[indexs[0]] : this.menus[indexs[0]].children[indexs[1]]
      this.selectLeftMenu(menu)
    },
    //图片加载
    getImage: function(icon){
      try {
        return require('@/assets/main/' + icon)
      } catch (e) {
        return require('@/assets/main/menu.png')
      }
    },
    collapseHandle(){
      this.isCollapse = !this.isCollapse
      this.$emit('collapseHandle', this.isCollapse)
    }
  }
}
</script>

<style scoped>
.collapse-box{
  height:46px;
  line-height:46px;
  color:white;
  text-align: center;
  background-color: rgb(44, 95, 154);
}
  .el-menu {
    border-right: none;
  }
  .el-menu-item {
    background-color: #175393 !important;
    color:white !important;
  }
  .el-menu-item:hover {
    background-color: #2c3a72 !important;
  }
  .menu-icon {
    width: 16px;
    height: 16px;
    padding: 3px 10px 0 5px;
  }
  .el-menu-item i {
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    color: white;
  }
  .el-submenu i {
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    color: white;
  }
  .left-menu {
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/Menu.vue